import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import type { ReactNode } from 'react'
import { icons } from './icons.ts'

/**
 * The header of one of the two panels: a brand-weak circle, an icon, a title.
 *
 * Shared because both review modes and both panels use it, and because the
 * guided pass shipped without it -- the right-hand panel started at the
 * progress rail, so the screen never said what it was a comparison *of*.
 */
export function CardHeader({
  title,
  icon,
  beside,
  children,
}: {
  title: string
  icon: IconDefinition
  /** Next to the title: what qualifies it, e.g. the receita on screen being attached by hand. */
  beside?: ReactNode
  /** Actions on the right of the title row, e.g. "Atualizar comparação". */
  children?: ReactNode
}) {
  return (
    <div className="border-stroke-weak bg-background-sunken flex flex-wrap items-center gap-2 rounded-t-[8px] border-b p-5">
      <span className="bg-fill-brand-weak flex h-8 w-8 shrink-0 items-center justify-center rounded-full">
        <FontAwesomeIcon icon={icon} className="text-icon-brand text-sm" aria-hidden="true" />
      </span>
      <span className="text-tH5 text-text-strong font-medium">{title}</span>
      {beside}
      {children !== undefined && <div className="ml-auto flex items-center gap-2">{children}</div>}
    </div>
  )
}

/** The two panels, named once so the pair cannot drift apart. */
export const PANEL = {
  prescription: { title: 'Receita', icon: icons.prescription },
  comparison: { title: 'Comparação', icon: icons.comparison },
} as const
